
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/signup",
      function () {
        return require("private-next-pages/partners/signup.js");
      }
    ]);
  